import BaseModel from './BaseModel';
import {ATTRIBUTE_TYPES, HitContainerAttribute} from '../../components';
import {required} from '@vuelidate/validators';

export default class QmSystem extends BaseModel {
  constructor({id, designation = undefined}) {
    super(id, '', designation);
    this.designation = designation;
  }

  static get apiRoute() {
    return 'qm_system';
  }

  static get listPageRoute() {
    return 'QmSystemList';
  }

  get apiRoute() {
    return QmSystem.apiRoute;
  }

  static get detailPageRoute() {
    return 'qmSystemDetail';
  }

  get detailPageRoute() {
    return QmSystem.detailPageRoute;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['designation', 'active']);
  }

  static get detailAttrs() {
    return this.getAttributes(['designation', 'active']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['designation', 'active']);
  }

  static get joinAttrsKey() {
    return ['designation', 'active'];
  }

  get fullDesignation() {
    return this.designation;
  }

  static get orderKey() {
    return 'designation';
  }

  static get joinFilterColumns() {
    return ['designation'];
  }

  static get allAttributes() {
    return {
      designation: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        validations: {required},
        tableProperties: {
          header: 'hit-app.common.designation',
          maxWidth: '2fr',
        },
      }),
      active: new HitContainerAttribute(ATTRIBUTE_TYPES.BOOLEAN, {
        creationValue: true,
        tableProperties: {
          header: 'hit-app.common.active',
          maxWidth: '0.25fr',
        },
      }),
    };
  }
}
